import React from 'react';
import PropTypes from 'prop-types';
import GetPlanData from 'app/utility/GetPlanData.js';

class PromoDefault extends React.Component {
    render() {
        return (
            <div className="no-promo">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <div className="promo-copy">
                    {this.props.main}
                </div>
                {this.props.subCopy ? (
                    <div className="sub-copy">
                        {this.props.subCopy}  
                    </div>
                ) : null}
                <div className="promo-action-button" role="button" onClick={this.props.buttonAction}>
                    {this.props.buttonLabel}
                </div>
                {this.props.help ? (
                     <div className="promo-help">
                        {this.props.help}
                    </div>
                ) : null }
            </div>
        );
    }
}

PromoDefault.displayName = "PromoDefault";

PromoDefault.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    main: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
    subCopy: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object
    ]),
    buttonLabel: PropTypes.string,
    buttonAction: PropTypes.func,
    help: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ])
};

PromoDefault.defaultProps = {
    image: null,
    main: "",
    subCopy: null,
    buttonLabel: "",
    buttonAction: () => {},
    help: null
};

export default PromoDefault;